import { connect } from 'react-redux'
import { reduxForm } from 'redux-form/immutable'
import { Map } from 'immutable'

import UserProtrackRating from './UserProtrackRating'
import { RATING_PROTRACK_FORM as FORM_NAME } from 'app/constants/protracks'
import { setProtrackRating } from 'store/entities/identity/actions'
import { activeProTrackLevel } from 'store/entities/identity/selectors'

const formProps = {
  form: FORM_NAME,
  enableReinitialize: true,
  destroyOnUnmount: false,
}

const mapStateToProps = state => ({
  previousProTrack: activeProTrackLevel(state),
})

const mergeProps = ({ previousProTrack, ...restState }, { dispatch }, ownProps) => {
  const proTrackLevelId = previousProTrack.get('id')
  return {
    ...restState,
    ...ownProps,
    previousProTrack,
    onSubmit: values => dispatch(setProtrackRating(values.set('proTrackLevelId', proTrackLevelId))),
    onDismiss: () => dispatch(setProtrackRating(Map({ proTrackLevelId }))),
  }
}

export default connect(mapStateToProps, null, mergeProps)(reduxForm(formProps)(UserProtrackRating))
